var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHelpDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.017 4c-1.25 0-2.063.516-2.703 1.438a.356.356 0 0 0 .094.5l.671.515a.37.37 0 0 0 .516-.062c.39-.485.688-.766 1.297-.766.484 0 1.078.297 1.078.766 0 .359-.297.53-.766.797-.562.312-1.296.703-1.296 1.671V9a.37.37 0 0 0 .375.375h1.14A.37.37 0 0 0 8.798 9v-.078c0-.672 1.953-.703 1.953-2.516C10.751 5.046 9.33 4 8.017 4M7.86 9.844c-.61 0-1.094.484-1.094 1.078S7.25 12 7.86 12a1.08 1.08 0 0 0 1.078-1.078A1.08 1.08 0 0 0 7.86 9.844"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;